// CancerOS reference UI. One module, one render per screen, hash routing.
//
//   #/chats[/<id>]     gSage, the home screen: conversation list + thread
//   #/consults[/<id>]  conversations shared with colleagues, and invitations
//   #/cases            casebooks: one card per patient
//   #/cases/<pid>      case report
//   #/files            uploads and casebook builds (#/documents still lands here)
//   #/research         saved long-running research tasks (#/analyses still lands here)
//   #/research/composer[/<analysis_id>]  build a research plan from boxes
//   #/annotate[/<file_id>[/<page>]]  draw on a page, save it as a new file
//   #/runs[/<run_id>]  workflow runs and questions
//
// gSage is also a slide-over from every other screen; opening it on a case
// attaches that casebook. One chat engine (mountChat) serves both surfaces.
// State that outlives a render lives in `S`.

import { h, replace } from "./core/dom.ts";
import { registerActions } from "./core/actions.ts";
import { root } from "./core/state.ts";
import { openComposer } from "./screens/composer.ts";
import { openAssistant } from "./chat/assistant.ts";
import { boot } from "./core/boot.ts";
import { refreshRail, render } from "./shell/shell.ts";

// Everything else reaches these through actions.ts; this is where they are
// handed over, before the first screen is drawn.
registerActions({ render, refreshRail, openAssistant, openComposer });

boot().catch((err) => {
  console.error(err);
  replace(root, h("div", { class: "empty" }, err.message));
});
